var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4788 21.0878C12.5 26.5642 12.5 34.3761 12.5 50C12.5 65.6239 12.5 73.4358 16.4788 78.9122C17.7638 80.6808 19.3192 82.2362 21.0878 83.5212C26.5642 87.5 34.3761 87.5 50 87.5C65.6239 87.5 73.4358 87.5 78.9122 83.5212C80.6808 82.2362 82.2362 80.6808 83.5212 78.9122C87.5 73.4358 87.5 65.6239 87.5 50C87.5 34.3761 87.5 26.5642 83.5212 21.0878C82.2362 19.3192 80.6808 17.7638 78.9122 16.4788C73.4358 12.5 65.6239 12.5 50 12.5C34.3761 12.5 26.5642 12.5 21.0878 16.4788C19.3192 17.7638 17.7638 19.3192 16.4788 21.0878ZM73.1616 39.5845C74.3128 38.2986 74.2036 36.323 72.9178 35.1718C71.6319 34.0206 69.6563 34.1297 68.5051 35.4155L54.4669 51.0955C51.6223 54.2727 49.7067 56.4011 48.0688 57.7777C46.5086 59.0891 45.5922 59.375 44.7917 59.375C43.9911 59.375 43.0747 59.0891 41.5145 57.7777C39.8767 56.4011 37.961 54.2727 35.1164 51.0954L31.4949 47.0504C30.3437 45.7645 28.368 45.6554 27.0822 46.8066C25.7964 47.9578 25.6872 49.9335 26.8384 51.2193L30.6147 55.4372C33.2641 58.3966 35.4739 60.8651 37.4931 62.5622C39.6291 64.3575 41.933 65.625 44.7917 65.625C47.6503 65.625 49.9542 64.3575 52.0902 62.5622C54.1094 60.8651 56.3192 58.3966 58.9686 55.4372L73.1616 39.5845Z",
    fill: "#31FFCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick_square.eb3c562d5337a6c999a67a76585731f9.svg";
export { ForwardRef as ReactComponent };